import React from 'react'

function DashboardTopHeading(props) {
  return (
    <div>
        <h3 className='HeadingText'>{props.text}</h3>
    </div>
  )
}

export default DashboardTopHeading;